import React, {useEffect, useState} from 'react';
import s from './PopupManagerEdit.module.css';
import style from '../PopupsCommonStyle.module.css';
import styleCart from '../../../Cart/Cart.module.css';
import GreenButton from '../../../../Components/Buttons/GreenButton';
import LightGreenButton from '../../../../Components/Buttons/LightGreenButton';
import {Field, Form, Formik, FormikHelpers} from 'formik';
import SelectSvgSelector from '../../../../Components/InputSelect/SelectSvgSelector';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '../../../../redux/store';
import CommonSvgSelector from '../../../../assets/common/SVG/CommonSvgSelector';
import {useUpdateOrderMutation} from '../../../../redux/userOrdersApi';
import {
	OrderViewType,
	UpdateOrderDataType,
} from '../../../../types/TypesUserOrders';
import TopCardElement from '../../../Cart/TopCardElement';
import DeliveryTypeSelector from '../../../../Components/DeliverySelector/DeliveryTypeSelector/DeliveryTypeSelector';
import PayTypeSelector from '../../../../Components/CreateAndEditOrderComponents/PayTypeSelector/PayTypeSelector';
import DeliveryAddressesSelector from '../../../../Components/DeliverySelector/DeliveryAdressesSelector/DeliveryAddressesSelector';
import ChangeContactSelector from '../../../../Components/CreateAndEditOrderComponents/ChangeContactSelector/ChangeContactSelector';
import {useTranslation} from 'react-i18next';
import {
	formatCityNameForNovaPoshta,
	handleApiCall,
	handleApiCallWithFullError,
} from '../../../../assets/utils/utils';
import {toast} from 'react-toastify';

type Props = {
	orderInfo: OrderViewType;
	close: () => void;
	orderId: number;
};
const PopupManagerEdit: React.FC<Props> = ({orderInfo, close, orderId}) => {
	const [editRecipient, setEditRecipient] = useState(false);
	const {t} = useTranslation();
	const [updateOrder] = useUpdateOrderMutation();

	const initialValues = {
		order_id: orderId ?? '',
		address_id: orderInfo.address_ref || '', // Используем address_ref как address_id
		address_ref: orderInfo.address_ref || '',
		address_name: orderInfo.address_name || '',
		contact_id: '', // Будет заполнен автоматически из селектора контактов
		payment_method: orderInfo?.payment_method || '',
		service_type: orderInfo?.service_type || '',
		service_token: '', // Будет заполнен автоматически из селектора сервисов
		service_name: '', // Будет заполнен автоматически из селектора сервисов
		delivery_typeForNP:
			orderInfo.delivery_type === 'branch' ? 'getWarehouses' : 'getStreet',
		delivery_type: orderInfo.delivery_type || 'door',
		country_ref: orderInfo.country_ref || '',
		country_name: orderInfo.country_name || '',
		region_ref: '',
		region_name: '',
		city_ref: orderInfo.city_ref || '',
		city_name: orderInfo.city_name || '',
		building: '',
		flat: '',
		recipient_name: orderInfo.recipient_name || '',
		recipient_phone: orderInfo.recipient_phone || '',
		newContactMiddlename: '',
		newContactPhone: '',
		newContactSurname: '',
		newContactName: '',
	};
	type InitialValuesType = typeof initialValues;
	const handleSubmit = async (
		values: InitialValuesType,
		{setStatus}: FormikHelpers<InitialValuesType>,
	) => {
		const formattedCityName = formatCityNameForNovaPoshta(
			values.city_name,
			values.service_type,
		);
		const data: UpdateOrderDataType = {
			order_id: values.order_id,
			address_id: values.address_id,
			contact_id: values?.contact_id?.toString(),
			payment_method: values.payment_method,
			service_type: values.service_type,
			delivery_type: values.delivery_type, // Тип відділення(відділення, поштомат або адреса)
			country_ref: values?.country_ref?.toString(),
			country_name: values?.country_name?.toString(),
			region_ref: values?.region_ref?.toString(),
			region_name: values?.region_name?.toString(),
			city_ref: values.city_ref,
			city_name: formattedCityName,
			address_ref: values.address_ref,
			address_name: values.address_name,
			building: values.building ? +values.building : 0,
			flat: values.flat ? +values.flat : 0,
			recipient_name: values.recipient_name,
			recipient_phone: values.recipient_phone,
		};
		await handleApiCallWithFullError({
			apiCall: () => updateOrder(data),
			onSuccess: (data) => {
				toast.success(data.message.textmsg);
				close();
			},
			onError: (error) => setStatus(error),
		});
	};
	return (
		<div className={style.wrapper}>
			<Formik
				enableReinitialize
				initialValues={initialValues}
				onSubmit={handleSubmit}
			>
				{({}) => (
					<Form className={`${style.container} ${s.container}`}>
						<button
							className={s.closeCrossContainer}
							type={'button'}
							onClick={close}
						>
							<CommonSvgSelector id={'closeCross'} />
						</button>
						<div className={s.title}>{t('Редагувати замовлення')}</div>
						<div className={s.subTitle}>
							<span>1</span>
							{t('Спосіб оплати')}
						</div>
						<PayTypeSelector />
						<div className={s.subTitle}>
							<span>2</span>
							{t('Спосіб доставки')}
						</div>
						<DeliveryTypeSelector />
						<div className={`${styleCart.addressContainer} ${s.addressInfo}`}>
							<TopCardElement title={t('Адреса доставки')} number={'3'} />
							<DeliveryAddressesSelector />
						</div>
						<div className={s.subTitle}>
							<TopCardElement title={'Контакти отримувача'} number={'4'} />
						</div>
						<ChangeContactSelector />
						{/*<div className={s.subTitle}>
							<TopCardElement title={'Контакт отримувача'} number={'5'} />
						</div>
						<div className={s.hideWrapper}>
							{!editRecipient ? (
								<div className={s.hideContainer}>
									<div className={s.name}>
										{orderInfo?.recipient_name || ''}
									</div>
									<LightGreenButton
										text={'Змінити'}
										type={'button'}
										onClick={() => setEditRecipient(!editRecipient)}
									/>
								</div>
							) : (
								<></>
							)}
							{editRecipient ? (
								<div className={style.editContainer}>
									<div className={style.editColumn}>
										<div className={style.fieldElement}>
											<div className={style.fieldElement_Name}>Имя</div>
											<div className={style.fieldElement_Input}>
												<span className={style.fieldIcon}>
													<SelectSvgSelector id={'nameIcon'} />
												</span>
												<Field
													className={style.input}
													placeholder={'Введите Имя'}
													name={'recipient_name'}
												/>
											</div>
										</div>
										<div className={style.fieldElement}>
											<div className={style.fieldElement_Name}>Телефон</div>
											<div className={style.fieldElement_Input}>
												<span className={style.fieldIcon}>
													<SelectSvgSelector id={'phone'} />
												</span>
												<Field
													className={`${style.input}`}
													placeholder={'Введите телефон'}
													name={'recipient_phone'}
												/>
												<Field className={`${style.input} ${style.error}`}
                                                       placeholder={"Введите телефон"}
                                                       name={"recipient_phone"}
                                                />
												 <span className={style.error}>ОШИБКА!</span>
											</div>
										</div>
									</div>
								</div>
							) : (
								<></>
							)}
						</div>*/}
						<div className={s.submitButton}>
							<GreenButton type={'submit'} text={'Зберегти зміни'} />
						</div>
					</Form>
				)}
			</Formik>
		</div>
	);
};

export default PopupManagerEdit;
